import {
  ENV,
  Environment,
  mockServerPort,
} from '@backoffice-frontend/environment'

const TripApiConfigurationStages: Record<Environment, string> = {
  [Environment.local]: `http://localhost:${mockServerPort}/api/trip-api-configuration`,
  [Environment.test]: `http://localhost:${mockServerPort}/api/trip-api-configuration`,
  [Environment.development]: `https://partner-events.api.trip.dev.moia-group.io`,
  [Environment.integration]: `https://partner-events.api.trip.int.moia-group.io`,
  [Environment.production]: `https://partner-events.api.trip.prd.moia-group.io`,
  [Environment['production.us-east-1']]:
    `https://partner-events.api.trip.prd.moia-group.io`,
}

const Host = TripApiConfigurationStages[ENV]

export const TripApiConfigurationEndpoints = {
  WebhookConfig: `${Host}/webhook`,
}
